export default "__VITE_ASSET__BKAFQZdP__"